var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFace5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_2943)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.15313 5.30191C2.22915 7.83946 1.47725 11.163 1.07918 14.3967C0.747462 17.1138 0.636889 19.9209 1.43302 22.5258C2.6051 26.3658 5.70116 29.3075 9.2174 30.7447C12.7336 32.1819 16.6258 32.2493 20.3411 31.6205C26.9534 30.5202 32.4379 24.21 32.7917 16.9791C33.3446 6.37981 23.592 -1.07563 14.348 0.137001C10.5222 0.631036 6.56363 2.09069 4.15313 5.30191Z",
    fill: "#FBE250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0014 5.16618C24.763 2.38162 20.4727 1.25881 17.8853 1.68548C17.4872 1.75285 17.642 2.33671 17.9737 2.38162C19.4997 2.58373 20.8486 2.87566 22.2419 3.61671C23.3918 4.22302 24.2101 5.27846 25.3379 5.88478C25.8023 6.1318 26.2225 5.63776 26.0014 5.16618Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.0425 6.60443C26.7108 6.55952 26.556 7.05355 26.7772 7.27812C27.2195 7.72724 27.7281 8.08654 28.1262 8.60303C28.5463 9.16443 28.7896 9.83812 29.2098 10.3995C29.4752 10.7588 29.9617 10.4444 29.9838 10.0627C30.0944 8.49075 28.4137 6.76162 27.0204 6.60443H27.0425Z",
    fill: "#FFE175"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57144 10.1048C7.73592 9.94756 6.16577 11.497 5.92251 13.316C5.87828 13.6079 6.16577 13.81 6.40903 13.6079C7.33785 12.777 7.78015 11.4746 9.2176 11.3848C10.6108 11.2949 11.0974 12.8669 11.7829 13.7426C12.0704 14.1244 12.7781 13.81 12.7338 13.3384C12.5569 11.8339 11.1416 10.2395 9.59355 10.1272L9.57144 10.1048Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3714 10.1048C25.2069 9.94756 26.7771 11.497 27.0203 13.316C27.0646 13.6079 26.7771 13.81 26.5338 13.6079C25.605 12.777 25.1627 11.4746 23.7253 11.3848C22.332 11.2949 21.8455 12.8669 21.1599 13.7426C20.8725 14.1244 20.1648 13.81 20.209 13.3384C20.3859 11.8339 21.8013 10.2395 23.3493 10.1272L23.3714 10.1048Z",
    fill: "#25368D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.44804 19.2219C7.09421 21.1756 9.46048 26.5202 16.5814 26.61C23.7024 26.6774 26.0907 19.6935 26.0244 18.9974C25.9581 18.3012 7.62496 18.3686 7.47016 19.2219H7.44804Z",
    fill: "#F26F59"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.449 19.2219C7.31631 19.8956 7.53746 21.0184 8.17879 22.1637C10.5672 21.0184 13.3536 20.6142 16.0074 20.3672C17.3343 20.2325 18.6833 20.1426 20.0102 20.3447C21.6688 20.5918 23.2168 21.2654 24.6543 22.1861C25.6494 20.6816 26.0475 19.2893 26.0033 18.9974C25.9369 18.3012 7.6038 18.3686 7.449 19.2219Z",
    fill: "#EF5345"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_2943"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.835938)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFace5);
export default __webpack_public_path__ + "static/media/icon-face-5.ece72d754b797352f59e296b43272894.svg";
export { ForwardRef as ReactComponent };